import { HelperConstant } from 'helpers/HelperConstant';
import { CustomButton } from 'components/shared/CustomButton';
import { CustomDatePicker } from 'components/shared/CustomDatePicker';
import { CustomDropdown } from 'components/shared/CustomDropdown';
import { UserNameData } from 'features/reducers/username/UserName.Reducers';
import { useTypedDispatch, useTypedSelector } from 'features/reduxhooks/ReduxHooks';
import moment from 'moment';
import React, { InputHTMLAttributes, useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom';
import { Row, Col, ModalFooter, Alert } from 'reactstrap';
import MasterService from 'services/Master.Service';
import PersonService from 'services/Person.Service';
import ProductTypeService from 'services/ProductType.Service';
import { FilterDataId } from 'features/reducers/filterdata/FilterData.Reducers';
import { CustomAutoComplete } from 'components/shared/CustomAutoComplete';
import GetDofyGeoListServices from 'services/GetDofyGeoList.Services';
import { unique } from "underscore";
import { IAssigneeListModal } from 'models/IAssigneeListModal';
import { createFilterOptions } from '@mui/material';
import { isRider } from '../../helpers/TokenHelper';
import { resetAllTiles_v1, updateDashboardFilter } from 'features/reducers/filterdata/DashboardFilter.Reducers';

interface inputProps extends InputHTMLAttributes<HTMLInputElement> {
    onClickSell: any,
    onClickRepair: any,
    filterOpen: any,
    dashboardStatId?: any
}

type Param = {
    routeId: any
}

function Filter({ onClickSell, onClickRepair, filterOpen, dashboardStatId }: inputProps) {
    let dispatch = useTypedDispatch();
    const { routeId } = useParams<Param>();
    let isCompletedTile: boolean = parseInt(routeId ?? "") === HelperConstant.dashboardNameIndex.CompletedOrders;
    let isCancelledTile: boolean = parseInt(routeId ?? "") === HelperConstant.dashboardNameIndex.CancelledOrders;
    let isFailedTile: boolean = parseInt(routeId ?? "") === HelperConstant.dashboardNameIndex.FailedOrders;
    const isAllCondtion = parseInt(routeId) === HelperConstant.dashboardNameIndex.AllOrders
    const isAppointmentDateCondtion = (parseInt(routeId) === HelperConstant.dashboardNameIndex.OpenOrders || parseInt(routeId) === HelperConstant.dashboardNameIndex.InProgressOrders)
    const isCompletedDateCondition = (parseInt(routeId) === HelperConstant.dashboardNameIndex.CancelledOrders || parseInt(routeId) === HelperConstant.dashboardNameIndex.FailedOrders || parseInt(routeId) === HelperConstant.dashboardNameIndex.ReturnOrders || parseInt(routeId) === HelperConstant.dashboardNameIndex.CompletedOrders || parseInt(routeId) === HelperConstant.dashboardNameIndex.CancelRequestOrders)
    // let productId = useTypedSelector(state => state.FilterDataReducers.productId);
    // let brandId = useTypedSelector(state => state.FilterDataReducers.BrandId);
    // let modelId = useTypedSelector(state => state.FilterDataReducers.ModelId);
    // let cityId = useTypedSelector(state => state.FilterDataReducers.CityId);
    // let riderId = useTypedSelector(state => state.FilterDataReducers.RiderId)
    // let PromoCode = useTypedSelector(state => state.FilterDataReducers.PromoCode);
    // let FromDate = useTypedSelector(state => state.FilterDataReducers.FromDate);
    // let ToDate = useTypedSelector(state => state.FilterDataReducers.ToDate);

    const segmentValue = localStorage.getItem("routeFrom") as any;

    let productId = useTypedSelector(state => state.DashboardFilterReducers[segmentValue][routeId].productId);
    let brandId = useTypedSelector(state => state.DashboardFilterReducers[segmentValue][routeId].BrandId);
    let modelId = useTypedSelector(state => state.DashboardFilterReducers[segmentValue][routeId].ModelId);
    let cityId = useTypedSelector(state => state.DashboardFilterReducers[segmentValue][routeId].CityId);
    let riderId = useTypedSelector(state => state.DashboardFilterReducers[segmentValue][routeId].RiderId);
    let PromoCode = useTypedSelector(state => state.DashboardFilterReducers[segmentValue][routeId].PromoCode);
    let FromDate = useTypedSelector(state => state.DashboardFilterReducers[segmentValue][routeId].FromDate);
    let ToDate = useTypedSelector(state => state.DashboardFilterReducers[segmentValue][routeId].ToDate);
    const riderlogin: boolean = isRider() ?? false;

    const [productList, setProductList] = useState<Array<any>>([]);
    const [brandList, setBrandList] = useState<Array<any>>([]);
    const [modelList, setModelList] = useState<Array<any>>([]);
    const [cityList, setCityList] = useState<Array<any>>([]);
    const [AssigneeList, setAssigneeList] = useState<Array<any>>([]);
    const [PromoCodes, setPromoCodes] = useState<Array<any>>([]);
    const [showFormDate, setShowFromDate] = useState(false);
    const [showToDate, setShowToDate] = useState(false);
    const [selected, setSelected] = useState<string>('');
    const [fromDate, setFromDate] = useState<any>('');
    const [toDate, setToDate] = useState<any>('');
    const [ProductTypevalue, setProductTypevalue] = useState<any>(0);
    const [brandValue, setBrandValue] = useState<any>(0);
    const [modelvalue, setModelvalue] = useState<any>(0);
    const [CityValue, setCityValue] = useState<any>(0);
    const [AssignValue, setAssignValue] = useState<any>(null);
    const [PromoCodeValue, setPromoCodeValue] = useState<any>(0);
    const [showCompletedFormDate, setShowCompletedFromDate] = useState(false);
    const [showCompletedToDate, setShowCompletedToDate] = useState(false);
    const [completedFromDate, setCompletedFromDate] = useState<any>('');
    const [completedToDate, setCompletedToDate] = useState<any>('');
    const [error, setError] = useState('');
    const [dofyGeoList, setDofyGeoList] = useState<Array<any>>([]);
    const [filterLocation, setFilterLocationList] = useState<Array<any>>([]);
    const [groupedLocation, setGroupedLocationList] = useState<Array<any>>([]);


    const ProductTypeServicesData = () => {
        setProductList([]);
        setBrandValue(0);
        setModelvalue(0);
        ProductTypeService.GetList().then(res => {
            if (res.status === 200) {
                setProductList(res.data);
            }
        }).catch(res => {
            console.log(res);
        });
    }

    const GetBrandMasterByProductId = (ProductId: any, holdValue?: "yes" | "no") => {
        setBrandValue(0);
        setModelvalue(0);
        setProductTypevalue(ProductId);
        if (ProductId > 0) {
            MasterService.GetBrandMasterByProductId(ProductId, HelperConstant.serviceTypeId.SELL).then(res => {
                if (res.status === 200) {
                    if (ProductId && ProductId > 0) {
                        setBrandList(res.data);
                        let name = res.data?.find((x => x?.ProductTypeId == ProductId))?.ProductTypeName;
                        // dispatch(FilterDataId({ payload: parseInt(ProductId), type: "ProductId" }));
                        // dispatch(FilterDataId({ payload: name, type: "ProductName" }));

                        dispatch(updateDashboardFilter({
                            sectionKey: segmentValue,
                            tileKey: dashboardStatId,
                            field: "productId",
                            fieldValue: parseInt(ProductId)
                        }))

                        dispatch(updateDashboardFilter({
                            sectionKey: segmentValue,
                            tileKey: dashboardStatId,
                            field: "productName",
                            fieldValue: name
                        }))
                        if (productId) {
                            // dispatch(FilterDataId({ payload: null, type: "BrandId" }));
                            // dispatch(FilterDataId({ payload: null, type: "ModelId" }));
                            dispatch(updateDashboardFilter({
                                sectionKey: segmentValue,
                                tileKey: dashboardStatId,
                                field: "BrandName",
                                fieldValue: null
                            }))
                            dispatch(updateDashboardFilter({
                                sectionKey: segmentValue,
                                tileKey: dashboardStatId,
                                field: "BrandId",
                                fieldValue: null
                            }))
                            dispatch(updateDashboardFilter({
                                sectionKey: segmentValue,
                                tileKey: dashboardStatId,
                                field: "ModalName",
                                fieldValue: null
                            }))
                            dispatch(updateDashboardFilter({
                                sectionKey: segmentValue,
                                tileKey: dashboardStatId,
                                field: "ModelId",
                                fieldValue: null
                            }))
                        }
                    }
                }
            });
        }
    }

    const GetSeriesModelByBrandMasterId = (BrandId: any, holdValue?: "yes" | "no") => {
        setModelList([]);
        setModelvalue(0);
        setBrandValue(BrandId);
        if (BrandId > 0) {
            MasterService.GetSeriesModelByBrandMasterId(BrandId, HelperConstant.serviceTypeId.SELL).then(res => {
                if (res.status === 200) {
                    if (BrandId && BrandId > 0) {
                        setModelList(res.data);
                        let name = res.data?.find((x => x?.BrandMasterId == BrandId))?.BrandMasterName;
                        // dispatch(FilterDataId({ payload: name, type: "BrandName" }));
                        // dispatch(FilterDataId({ payload: parseInt(BrandId), type: "BrandId" }));
                        dispatch(updateDashboardFilter({
                            sectionKey: segmentValue,
                            tileKey: dashboardStatId,
                            field: "BrandName",
                            fieldValue: name
                        }))
                        dispatch(updateDashboardFilter({
                            sectionKey: segmentValue,
                            tileKey: dashboardStatId,
                            field: "BrandId",
                            fieldValue: parseInt(BrandId)
                        }))
                        if (holdValue !== "yes") {
                            // dispatch(FilterDataId({ payload: null, type: "ModelId" }));
                            dispatch(updateDashboardFilter({
                                sectionKey: segmentValue,
                                tileKey: dashboardStatId,
                                field: "ModalName",
                                fieldValue: null
                            }))
                        }
                    }

                }
            }).catch(res => {
                console.log(res);
            });
        }
    }

    const GetModelId = (ModelId: any) => {
        if (ModelId && ModelId > 0) {
            let name = modelList?.find((x => x?.Id == ModelId))?.DisplayName;
            // dispatch(FilterDataId({ payload: name, type: "ModalName" }));
            // dispatch(FilterDataId({ payload: parseInt(ModelId), type: "ModelId" }));
            dispatch(updateDashboardFilter({
                sectionKey: segmentValue,
                tileKey: dashboardStatId,
                field: "ModalName",
                fieldValue: name
            }))

            dispatch(updateDashboardFilter({
                sectionKey: segmentValue,
                tileKey: dashboardStatId,
                field: "ModelId",
                fieldValue: parseInt(ModelId)
            }))

            setModelvalue(ModelId);
        }
    }



    const GetCityList = () => {
        setCityList([]);
        MasterService.GetDistrictList(HelperConstant.serviceTypeId.SELL).then(res => {
            if (res.status === 200) {
                let data = res.data;
                data = data.map((x) => ({
                    ...x,
                    Name: x.Name.replace(/\w+/g, (w) =>
                        w[0].toUpperCase() + w.slice(1).toLowerCase()
                    ),
                }));

                data.sort((a, b) => a.Name.localeCompare(b.Name));

                setCityList(data);
                var uniqueOptions = unique(data, "Name");
                setFilterLocationList(uniqueOptions);
            }
        }).catch(e => {
            console.log(e);
        });
    }

    const GetPromoCodes = () => {
        MasterService.GetPromoCodes().then(res => {
            if (res.status === 200) {
                setPromoCodes(res.data);
            }
        }).catch(e => {
            console.log(e);
        });
    }

    const GetAssigneeList = (id) => {
        PersonService.GetAssigneeList(id).then(res => {
            if (res.status === 200) {
                let data = res.data as Array<IAssigneeListModal>;
                let filteredAssignee = data.filter(x => x.cityId == parseInt(cityId));

                setAssigneeList((cityId != null) ? filteredAssignee : data);
            }
        }).catch(e => {
            console.log(e);
        });
    }


    const filterOptions = createFilterOptions({
        matchFrom: 'any',
        stringify: (option: IAssigneeListModal) => option.FirstName + option.LastName,
    });

    const cityFilterData = (city: any) => {
        if (city && city > 0) {
            let name = filterLocation?.find((x => x?.Identifier == city))?.Name;
            // dispatch(FilterDataId({ payload: name, type: "CityName" }));
            // dispatch(FilterDataId({ payload: city, type: "CityId" }));

            dispatch(updateDashboardFilter({
                sectionKey: segmentValue,
                tileKey: dashboardStatId,
                field: "CityName",
                fieldValue: name
            }))

            dispatch(updateDashboardFilter({
                sectionKey: segmentValue,
                tileKey: dashboardStatId,
                field: "CityId",
                fieldValue: city
            }))
            dispatch(updateDashboardFilter({
                sectionKey: segmentValue,
                tileKey: dashboardStatId,
                field: "RiderId",
                fieldValue: null
            }));
            dispatch(updateDashboardFilter({
                sectionKey: segmentValue,
                tileKey: dashboardStatId,
                field: "RiderName",
                fieldValue: null
            }));
            setCityValue(city);
        }
    }

    const assigneeListFilterDate = (Assign: any) => {
        if (Assign && Assign > 0) {
            let name = `${AssigneeList?.find((x => x?.Id == Assign))?.FirstName} ${AssigneeList?.find((x => x?.Id == Assign))?.AliasName ? `- ${AssigneeList?.find((x => x?.Id == Assign))?.AliasName}` : ""}`;

            dispatch(updateDashboardFilter({
                sectionKey: segmentValue,
                tileKey: dashboardStatId,
                field: "RiderName",
                fieldValue: name
            }))

            dispatch(updateDashboardFilter({
                sectionKey: segmentValue,
                tileKey: dashboardStatId,
                field: "RiderId",
                fieldValue: Assign
            }))

            setAssignValue(Assign);
        }
    }

    const PromoCodeFilterData = (PromoCode: any) => {
        if (PromoCode && PromoCode > 0) {
            let name = PromoCodes?.find((x => x?.Id == PromoCode))?.DisplayName;
            // dispatch(FilterDataId({ payload: name, type: "PromoCodeName" }));
            // dispatch(FilterDataId({ payload: PromoCode, type: "PromoCode" }));
            dispatch(updateDashboardFilter({
                sectionKey: segmentValue,
                tileKey: dashboardStatId,
                field: "PromoCodeName",
                fieldValue: name
            }))
            dispatch(updateDashboardFilter({
                sectionKey: segmentValue,
                tileKey: dashboardStatId,
                field: "PromoCode",
                fieldValue: PromoCode
            }))

            setPromoCodeValue(PromoCode);
        }
    }

    const reset = () => {
        dispatch(resetAllTiles_v1(segmentValue));

        setSelected("");
        filterOpen();
    }

    const datetime = (value: any) => {
        if (value) {
            // dispatch(FilterDataId({ payload: value, type: "FromDate" }));

            dispatch(updateDashboardFilter({
                sectionKey: segmentValue,
                tileKey: dashboardStatId,
                field: "FromDate",
                fieldValue: value
            }))

            if (moment(value).format("L") > moment(ToDate).format("L")) {
                // dispatch(FilterDataId({ payload: null, type: "ToDate" }));

                dispatch(updateDashboardFilter({
                    sectionKey: segmentValue,
                    tileKey: dashboardStatId,
                    field: "ToDate",
                    fieldValue: null
                }))

            }
            setTimeout(() => { setShowFromDate(false) }, 300);
        }
    }

    const datetime2 = (value: any) => {
        if (value) {
            // dispatch(FilterDataId({ payload: value, type: "ToDate" }));
            dispatch(updateDashboardFilter({
                sectionKey: segmentValue,
                tileKey: dashboardStatId,
                field: "ToDate",
                fieldValue: value
            }))
            setTimeout(() => { setShowToDate(false) }, 300);
        }
    }

    const dateValidation = () => {
        if (FromDate !== null) {
            const result = moment(FromDate).format();
            setFromDate(result);
        }
        if (ToDate !== null) {
            const result = moment(ToDate).format();
            setToDate(result);
        }
        // if (CompletedStartDate !== null) {
        //     const result = moment(CompletedStartDate).format();
        //     setCompletedFromDate(result);
        // }
        // if (CompletedEndDate !== null) {
        //     const result = moment(CompletedEndDate).format();
        //     setCompletedToDate(result);
        // }
    }

    // const completedStarttime = (value: any) => {
    //     if (value) {
    //         dispatch(FilterDataId({ payload: value, type: "CompletedStartDate" }));
    //         if (moment(value).format("L") > moment(CompletedEndDate).format("L")) {
    //             dispatch(FilterDataId({ payload: null, type: "CompletedEndDate" }));
    //         }
    //         setTimeout(() => { setShowCompletedFromDate(false) }, 300);
    //     }
    // }

    // const completedEndtime2 = (value: any) => {
    //     if (value) {
    //         dispatch(FilterDataId({ payload: value, type: "CompletedEndDate" }));
    //         setTimeout(() => { setShowCompletedToDate(false) }, 300);
    //     }
    // }

    const GetDofyGeoList = (serviceTypeId: number, LocationId?: any, response?: any) => {
        GetDofyGeoListServices.GetAllDofyGeo(serviceTypeId).then(res => {
            if (res.status === 200) {
                setDofyGeoList(res.data);
                var uniqueOptions = unique(res.data, "Name");
                setFilterLocationList(uniqueOptions);
            }
        }).catch(e => {
            console.log(e);
        });
    }

    useEffect(() => {
        ProductTypeServicesData();
        GetCityList();
        GetPromoCodes();
        dateValidation();
        // GetDofyGeoList(HelperConstant.serviceTypeId.SELL);
    }, []);

    useEffect(() => {
        GetAssigneeList(0);
    }, [CityValue !== 0 ? CityValue : null]);

    useEffect(() => {
        if (productId <= 0) {
            dispatch(updateDashboardFilter({
                sectionKey: segmentValue,
                tileKey: dashboardStatId,
                field: "BrandId",
                fieldValue: null
            }));
            dispatch(updateDashboardFilter({
                sectionKey: segmentValue,
                tileKey: dashboardStatId,
                field: "BrandName",
                fieldValue: null
            }))
            dispatch(updateDashboardFilter({
                sectionKey: segmentValue,
                tileKey: dashboardStatId,
                field: "ModelId",
                fieldValue: null
            }));
            dispatch(updateDashboardFilter({
                sectionKey: segmentValue,
                tileKey: dashboardStatId,
                field: "ModalName",
                fieldValue: null
            }))
        }
        if (brandId <= 0) {
            dispatch(updateDashboardFilter({
                sectionKey: segmentValue,
                tileKey: dashboardStatId,
                field: "ModelId",
                fieldValue: null
            }));
            dispatch(updateDashboardFilter({
                sectionKey: segmentValue,
                tileKey: dashboardStatId,
                field: "ModalName",
                fieldValue: null
            }))
        }

    }, [productId, brandId]);

    useEffect(() => {
        if (cityId === null) {
            dispatch(updateDashboardFilter({
                sectionKey: segmentValue,
                tileKey: dashboardStatId,
                field: "RiderId",
                fieldValue: null
            }));
            dispatch(updateDashboardFilter({
                sectionKey: segmentValue,
                tileKey: dashboardStatId,
                field: "RiderName",
                fieldValue: null
            }));
            GetAssigneeList(0);
        }
    }, [cityId]);

    // useEffect(() => {
    //     const autoTriggerMasters = () => {
    //         productId > 0 && GetBrandMasterByProductId(productId, "yes");
    //         brandId > 0 && GetSeriesModelByBrandMasterId(brandId, "yes");
    //         modelId > 0 && GetModelId(modelId);
    //     }
    //     autoTriggerMasters();
    // }, []);

    const SellOrRepair = [{
        id: 1,
        name: 'Sell',
        disable: false
    },
    {
        id: 2,
        name: 'Repair',
        disable: true
    }]

    const handleFromDateChange = (e) => {
        const newFromDate = e.target.value;
        datetime(e.target.value);
        setFromDate(e.target.value)
        if (moment(newFromDate).isSameOrBefore(ToDate)) {
            setFromDate(newFromDate);
            setError(''); // Reset error state
        } else {
            setError('From date must be Before To date.');
        }
        // if (isCompletedDateCondition) {
        //     completedStarttime(e.target.value);
        // }

    };

    const handleToDateChange = (e) => {
        const newToDate = e.target.value;
        datetime2(e.target.value);
        setToDate(e.target.value)
        if (moment(newToDate).isSameOrAfter(FromDate)) {
            setToDate(newToDate);
            setError(''); // Reset error state
        } else {
            setError('To date must be After From date.');
        }

        // if (isCompletedDateCondition) {
        //     completedEndtime2(e.target.value);
        // }
    };

    const onTextFieldChange = (e) => {
        let value = e.target.value;
        if (value.length == 1) {
            dispatch(updateDashboardFilter({
                sectionKey: segmentValue,
                tileKey: dashboardStatId,
                field: "RiderId",
                fieldValue: null
            }));
            dispatch(updateDashboardFilter({
                sectionKey: segmentValue,
                tileKey: dashboardStatId,
                field: "RiderName",
                fieldValue: null
            }))
        } else {
            dispatch(updateDashboardFilter({
                sectionKey: segmentValue,
                tileKey: dashboardStatId,
                field: "RiderName",
                fieldValue: value
            }))
        }
    }
    return (
        <React.Fragment>
            <div className="modal-body">
                <div className='justify-content-around'>
                </div>
                <Row>
                    <Col xl={3}>
                        <CustomDatePicker
                            label={'From Date'}
                            value={moment(FromDate).format('YYYY-MM-DD')}
                            onChange={handleFromDateChange} id={undefined} error={error} />
                        {error && <span className="text-danger font-size-10">{error}</span>}
                    </Col>
                    <Col xl={3}>
                        <CustomDatePicker
                            label={'To Date'}
                            value={moment(ToDate).format('YYYY-MM-DD')}
                            onChange={handleToDateChange} id={undefined} error={error} />
                    </Col>
                    {/* {(isCompletedTile || isCancelledTile || isFailedTile) &&
                        <>
                            <Col xl={3}>
                                <CustomDatePicker onChange={(e) => { completedStarttime(e.target.value); setCompletedFromDate(e.target.value); }} label={isFailedTile ? 'Failed From Date' : isCancelledTile ? 'Cancelled From Date' : 'Completed From Date'} id={undefined} value={undefined} error={undefined} />
                            </Col>
                            <Col xl={3}>
                                <CustomDatePicker label={isFailedTile ? 'Failed To Date' : isCancelledTile ? 'Cancelled To Date' : 'Completed To Date'} id={undefined} value={undefined} error={undefined} onChange={(e, v) => { completedEndtime2(e.target.value); setCompletedToDate(e.target.value); }} />
                            </Col>
                        </>} */}
                    <Col xl={3}>
                        <CustomDropdown label={'City'} id={'City'} value={(cityId != null) && cityId} data={filterLocation} onChange={(e) => cityFilterData(e.target.value)} error={undefined} valueField='Identifier' displayField='Name' />
                    </Col>
                    {!(riderlogin || parseInt(routeId) == HelperConstant.dashboardNameIndex.OpenOrders|| parseInt(routeId) == HelperConstant.dashboardNameIndex.PendingOrders) &&
                        <Col xl={3}>
                            <CustomAutoComplete label={"Rider"} data={AssigneeList} filterOptions={filterOptions} name={undefined} value={riderId} defaultValue={riderId} id={"Rider"} onChange={(e, v) => assigneeListFilterDate(v.Id)} error={undefined} touched={undefined} valueField='Id' displayField='FirstName' displayField3='LastName' displayField2='AliasName' onTextFieldChange={onTextFieldChange} />
                        </Col>}
                    <Col xl={3}>
                        <CustomDropdown label={'Promo Code'} id={undefined} value={(PromoCode != null) && PromoCode} data={PromoCodes} onChange={(e) => PromoCodeFilterData(e.target.value)} error={undefined} valueField='Id' displayField='Name' />
                    </Col>
                    <Col xl={3}>
                        <CustomDropdown label={'Gadget'} id={undefined} value={(productId != null) && productId} data={productList} onChange={(e) => GetBrandMasterByProductId(e.target.value, "yes")} error={undefined} valueField='Id' displayField='Name' />
                    </Col>
                    <Col xl={3}>
                        <CustomDropdown label={'Brand'} disabled={productId ? false : true} id={undefined} value={(brandId != null) && brandId} data={brandList} onChange={(e) => GetSeriesModelByBrandMasterId(e.target.value)} error={undefined} valueField='Id' displayField='Name' />
                    </Col>
                    <Col xl={3}>
                        <CustomDropdown label={'Model'} disabled={brandId ? false : true} id={undefined} value={(modelId != null) && modelId} data={modelList} onChange={(e) => GetModelId(e.target.value)} error={undefined} valueField='Id' displayField='Name' />
                    </Col>
                </Row>
            </div>
            <ModalFooter>
                <div className='d-flex justify-content-end mt-2'>
                    <CustomButton type={'button'} btnClassName={'btn-success'} iconClasssName={undefined} name={'Reset'} onClick={() => reset()} />
                </div>
            </ModalFooter>
        </React.Fragment >
    )
}

export default Filter